export default __webpack_public_path__ + "img/6cdefa8d57ffd43700a400096a762ce1.png";